import React, { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import Card from '../../../components/Card/Card'
import { WORLD_CUP_LEADERBOARD } from '../../../graphql/queries'

export default function WorldCupLeaderboardAdmin() {
  const { data: leaderboardData } = useQuery(WORLD_CUP_LEADERBOARD, {
    fetchPolicy: 'cache-and-network',
  })

  const leaderboard = useMemo(
    () => (Array.isArray(leaderboardData?.worldCupLeaderboard) ? leaderboardData.worldCupLeaderboard : []),
    [leaderboardData]
  )

  return (
    <Card className="worldcup-admin-card" hover={false}>
      <h3>Leaderboard</h3>
      {leaderboard.length === 0 ? <p className="worldcup-admin-help">Ingen point endnu.</p> : null}
      {leaderboard.map((row) => (
        <div className="worldcup-admin-leader-row" key={row.userId}>
          #{row.rank} {row.userName} · {row.totalPoints} point · Perfekte {row.perfectPredictions} · Joker {row.jokerPoints} · VM {row.worldChampionPoints}
        </div>
      ))}
    </Card>
  )
}
